import { render, staticRenderFns } from "./com_bottom_default.vue?vue&type=template&id=78a047f1&scoped=true"
import script from "./com_bottom_default.vue?vue&type=script&lang=js"
export * from "./com_bottom_default.vue?vue&type=script&lang=js"
import style0 from "./com_bottom_default.vue?vue&type=style&index=0&id=78a047f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a047f1",
  null
  
)

export default component.exports